const hotjarOptions = {
  id: +import.meta.env.VITE_HOTJAR_ID,
  isProduction: import.meta.env.MODE === 'production',
  snippetVersion: 6,
};

export default hotjarOptions;
